module.exports = __webpack_public_path__ + "static/media/plant-default.e494d9fa.svg";